import React from "react";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";
import { defaultBillingCompanyContextState } from "./BillingCompanyProvider.state";

export const BillingCompanyContext =
  React.createContext<IBillingCompanyContextState>(
    defaultBillingCompanyContextState,
  );
